import { createFileRoute } from "@tanstack/react-router";
import { guardEmployeeSurface } from "./-employee-surfaces";
import MeasureCenterPage from "@/app/employee/[id]/page";

export const Route = createFileRoute("/employee/$id/")({
  beforeLoad: ({ params }) => guardEmployeeSurface("measures", params.id),
  component: MeasureCenterPage,
});
